<template>
  <a-modal
    :visible="visible"
    dialogClass="custom-dialog"
    :width="width"
    :closable="false"
    :dialogStyle="dialogStyle"
    :maskStyle="maskStyle"
    :centered="true"
    :footer="null"
  >
    <div class="dialog-box">
      <div class="close-box" @click="didClick_hideDialog">
        <img
          class="close-dialog-icon cs"
          src="../../assets/images/dialog/close.png"
        />
      </div>

      <slot></slot>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "CustomDialog",
  props: {
    width: {
      type: String,
      default: document.documentElement.clientWidth <= 992 ? "80%" : "450px",
    },
  },
  data() {
    return {
      maskStyle: {
        background: "rgba(0, 0, 0, 0.5)",
      },
      dialogStyle: {
        borderRadius: "0",
        border: "0",
      },
      visible: false,
    };
  },
  mounted() {},
  methods: {
    showDialog() {
      //document.body.style.overflow = "hidden";
      this.visible = true;
    },
    hideDialog() {
      this.visible = false;
    },
    didClick_hideDialog() {
      this.visible = false;
      this.$emit("clearInput");
      this.$emit("clearCollectSusses");
      this.$emit("closePop");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ant-modal-content {
  border-radius: 0;
  background: #ffffff url("../../assets/images/dialog/dialogBg.png") no-repeat
    left bottom;
  background-size: 166px 110px;
}

@media (min-width: 992px) {
  .close-box {
    position: absolute;
    top: 16px;
    right: 26px;
    width: 30px;
    height: 30px;
    z-index: 2;
    .close-dialog-icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 14px;
    }
  }
  .dialog-content {
    width: 100%;
    min-height: 214px;
  }
}

@media (max-width: 992px) {
  .close-box {
    position: absolute;
    top: 26px;
    right: 26px;
    z-index: 2;
    width: 40px;
    height: 40px;
    .close-dialog-icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
    }
  }
}
</style>
